/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_reststopservice__dogarea3 = /** @type {(inputs: {}) => string} */ () => {
	return `Hundebereich`
};

const en_reststopservice__dogarea3 = /** @type {(inputs: {}) => string} */ () => {
	return `Canine space`
};

const es_reststopservice__dogarea3 = /** @type {(inputs: {}) => string} */ () => {
	return `Área canina`
};

const fr_reststopservice__dogarea3 = /** @type {(inputs: {}) => string} */ () => {
	return `Espace canin`
};

const it_reststopservice__dogarea3 = /** @type {(inputs: {}) => string} */ () => {
	return `Area canina`
};

const nl_reststopservice__dogarea3 = /** @type {(inputs: {}) => string} */ () => {
	return `Kynologisch gebied`
};

const pt_reststopservice__dogarea3 = /** @type {(inputs: {}) => string} */ () => {
	return `Área canina`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reststopservice__dogarea3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reststopservice__dogarea3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reststopservice__dogarea3", locale)
	if (locale === "de") return de_reststopservice__dogarea3(inputs)
	if (locale === "en") return en_reststopservice__dogarea3(inputs)
	if (locale === "es") return es_reststopservice__dogarea3(inputs)
	if (locale === "fr") return fr_reststopservice__dogarea3(inputs)
	if (locale === "it") return it_reststopservice__dogarea3(inputs)
	if (locale === "nl") return nl_reststopservice__dogarea3(inputs)
	return pt_reststopservice__dogarea3(inputs)
};
export { reststopservice__dogarea3 as "restStopService__dogArea" }